module.exports = __webpack_public_path__ + "img/b3.84670ce3.png";